import { getAllConnectionApps } from '@/data/connectionAppsCatalog'

export const TEXTAREA_LINE_HEIGHT_PX = 24
export const TEXTAREA_PADDING_TOP_PX = 4
// Home ask bar is the drafting surface — a long prompt stays readable and
// scrolls in place rather than being clipped to a few lines. The in-thread
// composer stays short so it does not swallow the transcript. Ten lines is
// --app-composer-input-max-height (240px); the CSS max-height is what actually
// caps the field, so this only has to agree with it.
export const TEXTAREA_MAX_VISIBLE_LINES_DEFAULT = 10
export const TEXTAREA_MAX_VISIBLE_LINES_COMPACT = 6
export const MAX_MESSAGE_ATTACHMENTS = 10
export const CONNECTION_APP_META_BY_SLUG = new Map(
  getAllConnectionApps().map((app) => [String(app.slug || '').toLowerCase(), app]),
)
